<template>
    <div @click.prevent.stop="cmOpener.open($event, id)"
         class="w-10 h-6 bg-next-gray-md-dark cursor-pointer text-center inset-0 flex items-center justify-center drag-handle">
        <i class="block text-center icon-opzioni"></i>
    </div>
    <teleport :to="teleport_to">
        <ContextMenu :id="id" :menu-class="menuClass" :cmOpener="cmOpener">
            <span v-if="!(context._alternativa || context._nuvola || context.nuvole || context.alternative)"
                  class="cursor-pointer hover:text-next-neu mb-2"
                  @click="$emit('toggleDescrizione')">{{isDescrizione(context)? 'Riga preventivo': 'Riga descrizione'}}</span>
            <span v-if="!(context._alternativa || context._nuvola || context.nuvole || context.alternative)"
                  class="cursor-pointer hover:text-next-neu mb-2"
                  @click="$emit('toggleOpzionale')">{{isOpzionale(context)? 'Riga preventivo': 'Riga opzionale'}}</span>
            <span v-if="!(context._alternativa || context._nuvola) && !context.nuvole && !isDescrizione(context) && !isOpzionale(context)"
                  class="cursor-pointer hover:text-next-neu mb-2"
                  @click="$emit('addAlternativa')">Riga alternativa</span>
            <span v-if="!(context._alternativa || context._nuvola) && !context.alternative  && !isDescrizione(context) && !isOpzionale(context)"
                  class="cursor-pointer hover:text-next-neu mb-2" @click="$emit('addNuvola')">Riga nuvola</span>
            <span v-if="!(context._alternativa || context._nuvola)"
                  class="cursor-pointer hover:text-next-neu mb-2" @click="$emit('duplicaRecord')">Duplica</span>
            <span v-if="(context._alternativa || context._nuvola)"
                  class="cursor-pointer hover:text-next-neu mb-2" @click="$emit('duplicaSottoRecord')">Duplica</span>
            <template v-if="context?.ne_fornitore">
                <router-link :to="{name:'DettaglioFornitore', params: {fid:context?.ne_fornitore?.id}}" class="cursor-pointer hover:text-next-neu mb-2">Vai al fornitore</router-link>
<!--                <router-link :to="{name:'Progetti', params: {id:cliente_id}}" class="cursor-pointer hover:text-next-neu mb-2">Altri progetti</router-link>-->
            </template>
            <span v-show="(context._alternativa)" class="cursor-pointer hover:text-next-neu mb-2"
                  @click="$emit('promuovi')">Rendi principale</span>
            <ConfirmDelete position="right" v-show="!(context._alternativa || context._nuvola)"
                           @cancella="$emit('cancella')">
                <span class="cursor-pointer hover:text-next-neu">Elimina</span>
            </ConfirmDelete>
            <ConfirmDelete position="right" v-show="(context._alternativa || context._nuvola)"
                           @cancella="$emit('eliminaSottoriga')">
                <span class="cursor-pointer hover:text-next-neu">Elimina sottoriga</span>
            </ConfirmDelete>

        </ContextMenu>
    </teleport>

</template>

<script lang="ts">
import {Options} from 'vue-class-component';
import {Vue} from 'vue-class-component';
import ContextMenu from "@/components/ContextMenu.vue";
import Attivita from "@/views/Attivita.vue";
import ConfirmDelete from "@/components/ConfirmDelete.vue";
import {StatiSottoprogetto} from "@/types";
import {mapGetters, mapState} from "vuex";

@Options({
    name: 'OffertaContextMenu',
    components: {Attivita, ContextMenu, ConfirmDelete},
    inheritAttrs: false,
    props: {
        menuClass: {
            type: String,
            default: 'false'
        },
        teleport_to: {
            type: String,
            required: true
        },
        context: Object,
        id: {
            type: String,
            required: true
        },
        cmOpener: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters('sprjDataManager', [
            'isDescrizione',
            'isOpzionale'
        ]),
    },
})

export default class OffertaContextMenu extends Vue {
}
</script>
